import { ReactNode } from 'react';
import styled from 'styled-components';
import { useDrawerContext } from './context';

export const Wrapper = styled.div<{ $isScrolledDown: boolean }>`
  border-top: ${({ theme }) => theme.spacing.values.single} solid #c3c3c5;
  padding: ${({ theme }) => theme.spacing.values.half};
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 0;
  ${({ theme, $isScrolledDown }) => ($isScrolledDown ? theme.elevations.smallShadow : null)};
  width: 100%;
  justify-content: end;
  background-color: inherit;
`;

export type DrawerFooterProps = {
  footer: ReactNode;
};

export const DrawerFooter = ({ footer }: DrawerFooterProps) => {
  const { contentScrollY: y } = useDrawerContext();

  return (
    <Wrapper data-test="drawer--footer" $isScrolledDown={y > 0}>
      {footer}
    </Wrapper>
  );
};
